// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"7b88a293","344":"611d6ebc","536":"0abb824b","844":"c89bef0a"}[chunkId] + ".chunk.css";
};